(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.offer-copy').forEach(function (copyBtn) {
      copyBtn.addEventListener('click', function () {
        const text = copyBtn.querySelector('h4').innerText;
        navigator.clipboard.writeText(text).then(() => {
          copyBtn.style.display = 'none';
          copyBtn.parentElement.querySelector('.copiedcode_text').style.display = 'block';
          setTimeout(() => {
            copyBtn.style.display = 'flex';
            copyBtn.parentElement.querySelector('.copiedcode_text').style.display = 'none';
          }, 1000);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
